
module.exports =
{
  search: require('./SocialTariff/search'),
  signups: require('./SocialTariff/signups'),
}